import CargoDetailsFcl from "./cargo-details-fcl.component";

export default CargoDetailsFcl;
